export default __webpack_public_path__ + "static/media/DGX-H200-2.8701d698.png";